import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  ListWorkflowsApiArg,
  ListWorkflowsApiResponse,
} from '../../types/k2/workflows';

type Request = {
  published?: boolean | null;
  page?: {
    number?: number;
    size?: number;
  };
};

type ServerRequest = ListWorkflowsApiArg;
type ServerResponse = ListWorkflowsApiResponse;

export const listWorkflowsK2 = async (
  request: Request = {},
  options: ServiceRequestConfig = {},
) => {
  const params = mapParams(request);

  const serverResponse: ServerResponse = await k2.get('/workflows', {
    params,
    showErrorToast: true,
    ...options,
  });

  return mapResponse(serverResponse);
};

const mapParams = (request: Request): ServerRequest => {
  return {
    published: request.published ?? undefined,
    page: {
      number: request.page?.number,
      size: request.page?.size,
    },
  };
};

const mapResponse = (serverResponse: ServerResponse) => {
  return {
    data: serverResponse.data.map((workflow) => ({
      id: workflow.id,
      ...workflow.attributes,
    })),
    meta: serverResponse.meta,
  };
};
